import { render, staticRenderFns } from "./MovementRuleNew.vue?vue&type=template&id=41c18e8e&scoped=true&"
import script from "./movement-rule-new.component.ts?vue&type=script&lang=js&"
export * from "./movement-rule-new.component.ts?vue&type=script&lang=js&"
import style0 from "./MovementRuleNew.vue?vue&type=style&index=0&id=41c18e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c18e8e",
  null
  
)

export default component.exports